import RightSidebarContainer from "../../../Components/Blog/RightSidebar";

const RightSidebar = () => {
  return <RightSidebarContainer />;
};

export default RightSidebar;
